import { IEventBus } from "../lib/eventing/events";
import { AppEventBus } from "./appEventBus";

export interface EventLogEntry {
  id: string;
  timestamp: number;
  namespace?: string;
  type: string;
}

export class EventLogger {
  private logs: EventLogEntry[] = [];
  private listeners: Set<(logs: EventLogEntry[]) => void> = new Set();

  constructor(eventBus: AppEventBus) {
    // Subscribe to all events across all namespaces
    eventBus.on(["workbookClassification", "alert"],(_payload, event) => {
      const logEntry: EventLogEntry = {
        id: event.id,
        timestamp: event.timestamp,
        namespace: event.namespace,
        type: event.type,
      };
      
      this.logs.push(logEntry);
      this.notifyListeners();
    });
  }

  /**
   * Get all logged events
   */
  getLogs(): EventLogEntry[] {
    return [...this.logs];
  }

  /**
   * Subscribe to log updates
   * @returns Unsubscribe function
   */
  subscribe(listener: (logs: EventLogEntry[]) => void): () => void {
    this.listeners.add(listener);
    // Immediately notify with current logs
    listener(this.getLogs());
    
    return () => {
      this.listeners.delete(listener);
    };
  }

  /**
   * Clear all logs
   */
  clear(): void {
    this.logs = [];
    this.notifyListeners();
  }

  private notifyListeners(): void {
    const logs = this.getLogs();
    this.listeners.forEach(listener => listener(logs));
  }
}
